import { useQuery } from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { type ElementalQuery, getElementals } from '~~/src/api/elementals'
import { getElementalHomeFeed } from '~~/src/api/feed'
import type { ElementalTypeEnum } from '~~/src/types/elemental'

export const useElementalFeaturedFeed = (type: ElementalTypeEnum, isFeatured: boolean, query: MaybeRef<ElementalQuery>) => {
  return useQuery({
    queryKey: (['prompts-featured', isFeatured, type, query] as const),
    queryFn: async ({ queryKey }) => {
      if (queryKey[1]) // Is featured
        return getElementals(queryKey[3])
      else
        return getElementalHomeFeed(queryKey[3])
    },
  })
}
